import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base_url } from "../Api/Api";
import { Loader } from "../Global/Loader";
import Navbar from "../Global/Navbar";
import Header from "../Global/Header";
import ItemEducation from "./itemEducation";

const Mainpage = (props) => {
  const [state, setState] = useState({
    data: null,
    loader: true,
  });

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("logined")) == null) {
      props.history.push(`/Entrance`);
    }
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      if (props.history.location.pathname == "/MainPage") {
        window.history.go(1);
      }
    };

    base_url
      .get("indexPage")
      .then((response) => {
        setState({
          ...state,
          data: response.data,
          loader: false,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  }, []);

  return (
    <div className={`instructpg main-page ${state.loader ? "" : "active"}`}>
      <Loader active={state.loader} />
      <Header />
      <div className="body-mpage">
        <div className="my-exams">
          <Link to="/myExams" className="item-exam">
            <div className="pic">
              <img src="/img/my-exams.svg" alt="my-exams" />
            </div>
            <h4> آزمون های من</h4>
          </Link>
        </div>
        <div className="my-webinars">
          <Link to="/myWebinars" className="item-webinar">
            <div className="pic">
              <img
                src="/img/how-to-monetize-your-webinar-content.svg"
                alt="how-to-monetize-your-webinar-content"
              />
            </div>
            <h4>وبینار های من</h4>
          </Link>
          <Link to="/suggestionCourse" className="item-webinar">
            <div className="pic">
              <img
                src="/img/products-online-courses.svg"
                alt="products-online-courses"
              />
            </div>
            <h4>کورس های پیشنهادی</h4>
          </Link>
        </div>

        {state.data == null ? (
          <div className="baner-lastnews">
            <h4>آخرین خبر</h4>
            <a></a>
          </div>
        ) : state.data.lastNews == null ? null : (
          <div className="baner-lastnews">
            <h4>آخرین خبر</h4>
            <Link to={`/news/inner-page/${state.data.lastNews.id}`}>
              <h4>{state.data.lastNews.title}</h4>
              <img src={state.data.lastNews.image} />
            </Link>
          </div>
        )}

        {state.data == null ? null : state.data.learningItems.length ===
          0 ? null : (
          <div className="card-mpage educ-mpage">
            <div className="row-title">
              <h4>محتوای آموزشی</h4>
            </div>
            <div className="body-cardpage">
              {state.data.learningItems.map((item) => (
                <ItemEducation key={item.item_id} data={item} type="home" />
              ))}
            </div>
          </div>
        )}
      </div>
      <Navbar />
    </div>
  );
};

export default Mainpage;
